/**
 * @generated SignedSource<<fd33c6eb6aecad7bb432401b5bb419d5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiCreditsPolicyDialogCreditsQuery$variables = Record<PropertyKey, never>;
export type aiCreditsPolicyDialogCreditsQuery$data = {
  readonly aiCredits: {
    readonly availableFreeCredits: number;
    readonly initialFreeCredits: number;
  } | null;
};
export type aiCreditsPolicyDialogCreditsQuery = {
  response: aiCreditsPolicyDialogCreditsQuery$data;
  variables: aiCreditsPolicyDialogCreditsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AICreditsSummary",
    "kind": "LinkedField",
    "name": "aiCredits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availableFreeCredits",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "initialFreeCredits",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCreditsPolicyDialogCreditsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiCreditsPolicyDialogCreditsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "4b9453c3cb104268d1eb9fd6e6ec8986",
    "id": null,
    "metadata": {},
    "name": "aiCreditsPolicyDialogCreditsQuery",
    "operationKind": "query",
    "text": "query aiCreditsPolicyDialogCreditsQuery {\n  aiCredits {\n    availableFreeCredits\n    initialFreeCredits\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d5cfa1fdfc1596b43aa1a1d11e692f7";

export default node;
